<template>

    <a :href="'/' + isLink">
        
        <div class="py-8 border rounded-md bg-gray-100 hover:bg-gray-50 text-center w-52 flex"> 
            <slot></slot>
        </div>
    </a>

</template>

<script>

export default {
    props: {
        visText: String,
        isLink: String,
    }
}
</script>